import { useState, useRef } from "react";
import useClickOutside from "./useClickOutside";

export const useTableDropdownLogic = () => {
  const [showTablesDropdown, setShowTablesDropdown] = useState(false);
  const tablesDropdownRef = useRef();
  const [showTablePopup, setTablePopup] = useState({
    show: false,
    type: "",
    title: "Item Code Table",
  });

  useClickOutside(tablesDropdownRef, () => setShowTablesDropdown(false));

  const handleDrpdnClick = (title, type) => {
    setTablePopup({ show: true, type: type, title: title });
  };

  const closeTablePopup = () => {
    setTablePopup((prev) => ({ ...prev, show: false }));
  };

  return {
    showTablesDropdown,
    setShowTablesDropdown,
    tablesDropdownRef,
    showTablePopup,
    handleDrpdnClick,
    closeTablePopup,
  };
};
